module.exports = __webpack_public_path__ + "static/img/14023C_R_02_20170815_LC.5a52dea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14023C_R_02_20170815_LC.png
// module id = E4BY
// module chunks = 0